module.exports = __webpack_public_path__ + "img/gsah-page.628966a4.png";